import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
// import AppRoutes from './AppRoutes';
import SideBar from './components/SideBar/SideBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header/Header';
import ProtectedRoute from './routes/ProtectedRoute';
import Login from './components/Login/Login';
import AppRoutes from './AppRoutes';
import './style.css';
import ViewDashboard from './components/Login/viewDashboard';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<ProtectedRoute><AppRoutes /></ProtectedRoute>}>
        {/* <Route element={<AppRoutes />}> */}
          <Route path="/*" element={<AppRoutes />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
